export enum AdminSearchTypes {
  NAME = 'Name',
  STUDIO = 'Studio',
  EMAIL = 'Email',
}

export enum BookingsSearchTypes {
  STUDIO_ID = 'StudioId',
  SERVICE_ID = 'ServiceId',
  MASTER_ID = 'MasterId',
  STATUS = 'Status',
}

// uncomment when back is fixed
export enum EmployeesSearchTypes {
  // Skill = "Skill",
  // Name = "Name",
  STUDIO = 'Studio',
  SERVICE = 'Service',
  RANK = 'Rank',
}

export enum ServicesSearchTypes {
  SERVICE = 'Service',
  CATEGORY = 'Category',
  SUBCATEGORY = 'Subcategory',
}

export enum StudiosSearchTypes {
  NAME = 'Name',
  ADDRESS = 'Address',
}

export enum WorkingTimeSearchTypes {
  NAME = 'Name',
  STUDIO = 'Studio',
}

export enum ClientSearchTypes {
  NAME = 'Name',
  PHONE = 'Phone',
  EMAIL = 'Email',
}

export type ToggleBoxProps<T extends string> = {
  onSelected: (nextSelected: T) => void;
  label: T;
  selected: T;
  style?: any;
};
